module.exports = __webpack_public_path__ + "static/media/card-bg.aacee14b.png";